import create from 'zustand';

interface AIAudioPlayerState {
  isLoading: Record<string, boolean> | null;
  setIsLoading: (messageId: string, isLoading: boolean) => void;
  isPlaying: string;
  setIsPlaying: (isPlaying: string) => void;
  audioFiles: Record<string, string> | null;
  addAudio: (messageId: string, audioFile: string) => void;
  getAudio: (messageId: string) => string | undefined;
  audioPlayer: HTMLAudioElement;
}

export const useAIAudioPlayerState = create<AIAudioPlayerState>((set, get) => ({
  isLoading: null,
  setIsLoading: (messageId: string, isLoading: boolean) =>
    set((state) => ({
      isLoading: {
        ...state.isLoading,
        [messageId]: isLoading,
      },
    })),
  isPlaying: '',
  setIsPlaying: (isPlaying) => set({ isPlaying }),
  audioFiles: null,
  addAudio: (messageId: string, audioFile: string) =>
    set((state) => ({
      audioFiles: {
        ...state.audioFiles,
        [messageId]: audioFile,
      },
    })),
  getAudio: (messageId: string) => get().audioFiles?.[messageId],
  audioPlayer: new Audio(),
}));
